import React, {useContext} from "react";

export const Lotto12Context = React.createContext();

export const useLotto12 = () => useContext(Lotto12Context);
